<script setup>
import { computed } from 'vue';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

const props = defineProps({
  leadDistribution: {
    type: Object,
    default: () => ({}),
  },
});

const {
  created_at: arrivalTime = '',
  team: { first_interaction_deadline_minutes: maxResponseTime = 0 } = {},
} = props.leadDistribution;

const title = 'Lead Perdido 😔';
const arrivalTimeLabel = 'Chegada do lead:';
const maxResponseTimeLabel = 'Prazo de atendimento:';

const maxResponseTimeValue = computed(() => `${maxResponseTime} minutos`);

const formattedArrivalTime = computed(() => {
  if (!arrivalTime) return '';

  try {
    const date = new Date(arrivalTime);
    // Format: DD/MM/yyyy às HH:mm'h'
    return format(date, "dd/MM/yyyy 'às' HH:mm'h'", { locale: ptBR });
  } catch (error) {
    console.error('Error formatting date:', error);
    return arrivalTime;
  }
});

const leadInfoData = computed(() => [
  { label: arrivalTimeLabel, value: formattedArrivalTime.value },
  { label: maxResponseTimeLabel, value: maxResponseTimeValue.value },
]);
</script>

<template>
  <div
    class="flex-1 space-y-3 rounded-xl shadow-md border p-6 bg-red-50 dark:bg-red-900/20 border-red-200 dark:border-red-800"
  >
    <h3
      class="text-base font-semibold text-center text-red-900 dark:text-red-100"
    >
      {{ title }}
    </h3>
    <div class="space-y-2 text-sm text-red-800 dark:text-red-200">
      <div
        v-for="({ label, value }, index) in leadInfoData"
        :key="index"
        class="flex justify-between items-center"
      >
        <span class="text-red-700 dark:text-red-300">
          {{ label }}
        </span>
        <span class="text-red-900 dark:text-red-100">
          {{ value }}
        </span>
      </div>
    </div>
  </div>
</template>
